import { render } from "./equipos_marcas.vue?vue&type=template&id=0a5f311b"
import script from "./equipos_marcas.vue?vue&type=script&lang=js"
export * from "./equipos_marcas.vue?vue&type=script&lang=js"

import "./equipos_marcas.vue?vue&type=style&index=0&id=0a5f311b&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__